import { MODULES } from "./roles";
import useRoleCheck from "./useRoleCheck";

/**
 * @param {Array} tabs - Array of tab config objects. Each tab may include:
 *   - `roles`: string[] — show tab only if user hasAnyRole
 *   - `visible`: boolean — explicit override; if provided, takes precedence over `roles`
 * @param {string} [moduleKey=MODULES.PROJEKTI] - The module to check roles against
 * @returns {Array} Filtered array of tabs visible to the current user
 */
const useVisibleTabs = (tabs, moduleKey = MODULES.PROJEKTI) => {
  const { hasAnyRole } = useRoleCheck(moduleKey);
  return tabs.filter((tab) => {
    if (tab.visible !== undefined) return tab.visible;
    return !tab.roles || hasAnyRole(tab.roles);
  });
};

export default useVisibleTabs;
